import {FC, useState} from "react";
import {DocumentEditor} from "@onlyoffice/document-editor-react";
import {FILE_API_BASE_URL, ONLY_OFFICE_API_BASE_URL, wordFileTypes} from "../utils/config";
import uploadFileToServer, {getChangedFile} from "../utils/FileApiHook";

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 20 MB

interface EditorProps {
    onBack?: () => void;
}

const Editor: FC<EditorProps> = ({onBack}) => {
    const documentKey = `doc-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const [file, setFile] = useState<File | null>(null);
    const [fileName, setFileName] = useState<string | null>(null);
    const [progress, setProgress] = useState(0);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            if (event.target.files?.[0].size > MAX_FILE_SIZE) {
                alert("File size must be less than 10 MB");
                setFile(null);
                return;
            }
            setFile(event.target.files[0]);
        }
    };

    const uploadFile = async () => {
        if (!file) {
            alert("Please select a file");
            return;
        }
        const renamedFile = await getChangedFile(file);
        await uploadFileToServer(renamedFile, setProgress);
        setFileName(renamedFile.name);
    };

    return (
        <div style={{maxWidth: "100%", margin: "0 auto", padding: "40px"}}>
            {/* Back Button */}
            {onBack && (
                <button
                    onClick={onBack}
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "#2563eb",
                        fontSize: 14,
                        fontWeight: 600,
                        cursor: "pointer",
                        marginBottom: 24,
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                    }}
                >
                    ← Back to Home
                </button>
            )}
            {/*display if progress is less tha 100%*/}
            {progress < 100 && (
                <div className="upload-page">
                    <div className="upload-card">
                        <label className="upload-zone">
                            <span>📁 Choose a file</span>
                            <input
                                type="file"
                                accept={wordFileTypes.map(type => `.${type}`).join(",")}
                                onChange={handleFileChange}
                            />
                        </label>
                        <div>
                            <p style={{fontSize: 13, color: "#aaa"}}>
                                Supports DOC • Max 10 MB
                            </p>
                        </div>
                        {file && (
                            <div className="file-info">
                                <strong>{file.name}</strong>
                                <span>
                    ({Math.round(file.size / 1024)} KB)
                </span>
                            </div>
                        )}

                        <button
                            className="upload-button"
                            onClick={uploadFile}
                            disabled={!file}
                        >
                            Upload
                        </button>

                        {progress > 0 && (
                            <div className="progress-wrapper">
                                <div className="progress-container">
                                    <div
                                        className="progress-fill"
                                        style={{width: `${progress}%`}}
                                    >
                                        {progress}%
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            <div style={{height: "100vh", width: "100%"}}>
                {/*display document editor only when filename is set and progress is 100 percent*/}
                {fileName && progress === 100 && (
                    <DocumentEditor
                        id="docEditor"
                        documentServerUrl={ONLY_OFFICE_API_BASE_URL}
                        config={{
                            document: {
                                fileType: "docx",
                                key: documentKey,
                                title: fileName,
                                // url: FILE_API_BASE_URL + "/files/sample.doc"
                                url: FILE_API_BASE_URL + "/files/" + fileName
                            },
                            documentType: "word",
                            editorConfig: {
                                mode: "edit",
                                lang: "en",
                            },
                            type: "desktop"
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default Editor;